"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configure = require("../configure");
var date_format_1 = require("../util/date-format");
var dateMath = require("../util/date-arithmetic");
function default_1() {
    var localizer = simpleDateLocalizer();
    configure.setDateLocalizer(localizer);
    return localizer;
}
exports.default = default_1;
function simpleDateLocalizer() {
    function endOfDecade(date) {
        date = dateMath.add(date, 10, 'year');
        date = dateMath.add(date, -1, 'milliseconds');
        return date;
    }
    function endOfCentury(date) {
        date = dateMath.add(date, 100, 'year');
        date = dateMath.add(date, -1, 'milliseconds');
        return date;
    }
    var localizer = {
        formats: {
            date: 'L',
            time: 'LT',
            default: 'lll',
            header: 'MMMM YYYY',
            footer: 'LL',
            weekday: 'dd',
            dayOfMonth: 'DD',
            month: 'MMM',
            year: 'YYYY',
            decade: function (date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture)
                    + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
            },
            century: function (date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture)
                    + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
            }
        },
        startOfWeek: function () {
            return 0;
        },
        parse: function (value, format, culture) {
            if (!value) {
                return null;
            }
            try {
                return new Date(Date.parse(value));
            }
            catch (err) {
                console.log(err);
            }
            return null;
        },
        format: function (value, format, culture) {
            return date_format_1.dateFormat(value, format);
        }
    };
    return localizer;
}
exports.simpleDateLocalizer = simpleDateLocalizer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/localizers/simple-date-localizer.js
// module id = 457
// module chunks = 0 1 2 3 4 5 6